import { get, post } from './http-calls';

export let getTCardPriorityByID = async (id) => {
    let data = await get(`TCardPriorities/TCardPriorities_GetDetails?TCardPriorityID=${id}`, { useAuthToken: true });
    return data;
};

export const postTCardPriority = async (data) => {
    let res = await post(`TCardPriorities/TCardTCardPriority_AddUpdate`, data, { useAuthToken: true });
    return res;
};
